import {useMutation} from "@tanstack/react-query";

import {updateSupplierFunctionMutationOptions} from "./update-supplier-function.mutation-options";

export function useUpdateSupplierFunction(supplierFunctionId: string) {
  return useMutation(updateSupplierFunctionMutationOptions(supplierFunctionId));
}
